/*
 * 文件校验策略
 * @author sy
 * @date 2018-3-23
 */

import VUEUpLoad from './upload-config.js'

class Validate {
  constructor () {
    this.cache = []
  }

  add (file, rules) {
    for (let rule of rules) {
      let strategyAry = rule.strategy.split(':')
      // let errorMsg = rule.errorMsg
      this.cache.push(() => {
        let strategy = strategyAry.shift()
        strategyAry.unshift(file)
        // strategyAry.push(errorMsg)
        return strategies[strategy].apply(file, strategyAry)
      })
    }
  }

  check (file) {
    const err = new Error()
    for (let s of this.cache) {
      let errObj = s(file)
      if (errObj) {
        err.code = errObj.code
        err.message = errObj.message
        return err
      }
    }
  }
}

const strategies = {
  QUEUE_LIMIT_EXCEEDED (file, queueLimit, num) {
    if (queueLimit && queueLimit === num) {
      return {
        code: VUEUpLoad.QUEUE_ERROR.QUEUE_LIMIT_EXCEEDED,
        message: 'queue limit is ' + queueLimit
      }
    }
  },
  ZERO_BYTE_FILE (file) {
    if (file.size === 0) {
      return {
        code: VUEUpLoad.QUEUE_ERROR.ZERO_BYTE_FILE,
        message: 'file size zero'
      }
    }
  },
  FILE_EXCEEDS_SIZE_LIMIT (file, size) {
    if (size && file.size > (size * 1024)) {
      return {
        code: VUEUpLoad.QUEUE_ERROR.FILE_EXCEEDS_SIZE_LIMIT,
        message: 'file too larger'
      }
    }
  },
  INVALID_FILETYPE (file, accept) {
    if (accept && accept !== '*' && accept.indexOf(file.type) === -1) {
      return {
        code: VUEUpLoad.QUEUE_ERROR.INVALID_FILETYPE,
        message: 'file type is not allowed'
      }
    }
  }
}

export default Validate



// WEBPACK FOOTER //
// ./src/components/upload/upload_vue/upload-validate.js